import { FormMetadataValues } from '../types'

const createEmptyMetadata = (
  override?: Partial<FormMetadataValues>
): FormMetadataValues => ({
  accessRights: null,
  altTopic: [],
  contact: null,
  countries: [],
  departments: [],
  description: '',
  effective_at: '',
  language: '',
  legal_entities: [],
  locations: [],
  subject: '',
  mainTopic: null,
  target_group: '',
  title: '',
  code: '',
  externalReferenceLinks: [],
  ...override,
})

export default createEmptyMetadata
